module.exports = __webpack_public_path__ + "img/delete-icon.d10cba5a.svg";